import { Award } from "lucide-react";
import { useTranslation } from "../../../i18n";
import "../../../styles/gamification.css";

interface AchievementPopupProps {
    /** The milestone just reached (e.g. 100). null hides the popup. */
    milestone: number | null;
    /** Bump on each new achievement so the animation re-fires. */
    bumpKey: number;
}

/**
 * Celebration shown in the same overlay slot as the time-bonus / BEST badge,
 * fired when the operator crosses an item milestone (every 100 sorted). A
 * spinning medal + confetti so a milestone reads as a reward, not just a number.
 */
const AchievementPopup = ({ milestone, bumpKey }: AchievementPopupProps) => {
    const { t } = useTranslation();
    if (milestone === null) return null;
    return (
        <div className="gamif-achievement" key={bumpKey}>
            <div className="gamif-achievement-card">
                <Award className="gamif-achievement-icon" aria-hidden="true" />
                <span className="gamif-achievement-label">{t("achievement_label")}</span>
                <span className="gamif-achievement-value">{t("achievement_items", { count: milestone })}</span>
                {Array.from({ length: 12 }, (_, i) => (
                    <span key={i} className={`gamif-confetti-piece gamif-confetti-piece-${i + 1}`} />
                ))}
            </div>
        </div>
    );
};

export default AchievementPopup;
